import { Type } from '@sinclair/typebox';
import { cartAttributes } from "../cart/index.mjs";
import { parts } from "../atlas.mjs";
export const productItemSchema = Type.Object({
    attributes: cartAttributes,
    productFamilyName: Type.String(),
    productName: Type.String(),
    // TODO: Are these relevant to have here? If checkout isn't using them, we can remove them and
    // just let the editor store data in whatever format it wants.
    sku: Type.Optional(Type.String()),
    settings: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    svgSettings: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    ui: Type.Optional(Type.Array(Type.Unknown())),
});
const knownCustomStickerAttributes = Type.Object({ quantity: Type.Optional(Type.Number()) });
export const customStickerSchema = Type.Object({
    /**
     * Url to a preview image of the custom sticker.
     */
    imageUrl: Type.Optional(Type.String()),
    cartId: Type.Optional(Type.String()),
    attributes: Type.Intersect([knownCustomStickerAttributes, Type.Record(Type.String(), Type.Unknown())]),
    parts: parts,
    productItem: productItemSchema,
});
export const customStickerWithIdSchema = Type.Intersect([
    customStickerSchema,
    Type.Object({
        id: Type.String(),
        version: Type.String(),
    }),
]);
export const saveCustomStickerRequestSchema = Type.Object({
    customSticker: Type.Omit(customStickerSchema, ['cartId']),
});
export const customStickerResponseSchema = Type.Object({
    customSticker: customStickerWithIdSchema,
});
//# sourceMappingURL=index.js.map